import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import CloseIcon from "@mui/icons-material/Close";
import HeadsetIcon from "@mui/icons-material/Headset";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import AudioPlayer from "react-h5-audio-player";
import { Link, useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import BottomNav from "../../components/bottom-nav";
import Footer from "../../components/footer";
import Header from "../../components/header";
import PDFViewer from "../../components/PDFViewr";
import SideBar from "../../components/sideBar";
import { BASE_URL, CLIENT_REF } from "../../config/app.config";
import * as bookServices from "../../services/book.services";
import * as userServices from "../../services/user.services";
import "./bookDetails.css"; // Import your CSS file
import { OfflinePin, CloudDownload } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
const API_URL = `${BASE_URL}books`;
const BookDetails = () => {
  const [book, setBook] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [contentShown, setContentShown] = useState(true);
  const [isResourceInCache, setIsResourceInCache] = useState(false);
  const [userHasTheBook, setUserHasTheBook] = useState(false);
  const [viewSample, setViewSample] = useState(false);
  const bookId = useParams().bookId;
  const history = useHistory();
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [selectedMediaTypes, setSelectedMediaTypes] = useState(["All"]);
  const [codesInfo, setCodesInfo] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [openAccordions, setOpenAccordions] = useState({});
  const [hasPDF, setHasPDF] = useState(false);
  const [hasMedia, setHasMedia] = useState(false);
  const [isPDFCached, setIsPDFCached] = useState(false);
  const [isMediaCached, setIsMediaCached] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [showDownloadIndicator, setShowDownloadIndicator] = useState(false);
  const [currentDownloadFile, setCurrentDownloadFile] = useState('');
  const mediaTypes = [
    { value: "audio", label: "Audio" },
    { value: "video", label: "Video" },
    { value: "pdf", label: "PDF" },
    { value: "All", label: "All" },
  ];
  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };
  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      if (
        localStorage.getItem("playingAudio") == "true" &&
        !location.pathname.includes("/bookDetails")
      ) {
        // If the user tries to navigate away, pause the audio
        localStorage.setItem("playingAudio", false);
        window.location.reload();
      }
    });

    return () => {
      unlisten(); // Cleanup the listener when the component unmounts
    };
  }, [history]);
  useEffect(() => {
    bookServices
      .getBookById(bookId)
      .then((res) => {
        setBook(res.data);
        
        // Check if book has PDF (digital edition)
        const bookHasPDF = res.data.digitalEdition ? true : false;
        setHasPDF(bookHasPDF);
        
        // Check if book has media
        const bookHasMedia = res.data.pages && res.data.pages.some(page => 
          (page.voiceFiles && page.voiceFiles.length > 0) || 
          (page.videoFiles && page.videoFiles.length > 0)
        );
        setHasMedia(bookHasMedia);
        
        // Remove auto-caching of digital edition
        // if (bookHasPDF) {
        //   autoCacheDigitalEdition(res.data.digitalEdition);
        // }
        
        userServices
          .getUserBooks(localStorage.getItem("id"))
          .then((userBooks) => {
            const userHasTheBook = userBooks.data.some(
              (userBook) => userBook.codeBase === res.data.codeBase
            );
            if (userHasTheBook) {
              setUserHasTheBook(true);
              setIsLoading(false);
            } else {
              window.location.href = "/userBooks";
            }
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [bookId]);

  useEffect(() => {
    async function isResourceInCache(url) {
      try {
        const cache = await caches.open("appV1");
        const response = await cache.match(url);
        if (response) {
          setIsResourceInCache(true);
        }
      } catch (error) {
        console.error("Error checking cache:", error);
        return false;
      }
    }
    isResourceInCache(`${API_URL}/get-book-by-id/${CLIENT_REF}/${book._id}`);
  }, [book, isDownloading]);

  // Check if media files are cached
  useEffect(() => {
    const checkMediaCache = async () => {
      if (!book.pages || !hasMedia) return;
      
      try {
        const cache = await caches.open("appV1");
        let mediaChecks = [];
        
        // Check all audio files
        book.pages.forEach(page => {
          if (page.voiceFiles) {
            page.voiceFiles.forEach(file => {
              const url = file.url.replace(
                "https://redsea-books-assets.s3.eu-central-1.amazonaws.com",
                "https://dng2cduv9v2yj.cloudfront.net"
              );
              mediaChecks.push(cache.match(url));
            });
          }
          
          // Check all video files
          if (page.videoFiles) {
            page.videoFiles.forEach(file => {
              const url = file.url.replace(
                "https://redsea-books-assets.s3.eu-central-1.amazonaws.com",
                "https://dng2cduv9v2yj.cloudfront.net"
              );
              mediaChecks.push(cache.match(url));
            });
          }
        });
        
        const mediaResults = await Promise.all(mediaChecks);
        // If any media file is cached, set media as cached
        if (mediaResults.some(result => result !== undefined)) {
          setIsMediaCached(true);
        } else {
          setIsMediaCached(false);
        }
      } catch (error) {
        console.error("Error checking media cache:", error);
      }
    };
    
    checkMediaCache();
  }, [book, hasMedia]);

  // Also check PDF cache status
  useEffect(() => {
    const checkPdfCache = async () => {
      if (!book.digitalEdition || !hasPDF) return;
      
      try {
        const cache = await caches.open("appV1");
        const cachedResponse = await cache.match(book.digitalEdition);
        
        setIsPDFCached(!!cachedResponse);
      } catch (error) {
        console.error("Error checking PDF cache:", error);
      }
    };
    
    checkPdfCache();
  }, [book, hasPDF]);

  const toggleSidebar = () => {
    const sidebarContent = document.querySelector(".sidebar");
    const mainContent = document.querySelector(".page-container");
    const bookMetaGrid = document.querySelector(".book-meta-grid");
    if (sidebarContent.classList.contains("collapsed")) {
      sidebarContent.classList.remove("collapsed");
      mainContent.classList.toggle("wider");
      bookMetaGrid.classList.toggle("wider");
    } else {
      sidebarContent.classList.toggle("collapsed");
      mainContent.classList.remove("wider");
      bookMetaGrid.classList.remove("wider");
    }
    const sidebarContentMobile = document.querySelector(".floating-index-bar");
    if (sidebarContentMobile.classList.contains("collapsed")) {
      sidebarContentMobile.classList.remove("collapsed");
    } else {
      sidebarContentMobile.classList.toggle("collapsed");
    }
    setContentShown(!contentShown);
  };

  const toggleAudioControls = (page, pageNumber) => {
    const audioControls = document.querySelector(
      `.audio-play-buttons_${page}_${pageNumber}`
    );
    const isOpen = audioControls.style.display !== "block";
    
    audioControls.style.display = isOpen ? "block" : "none";
    
    // Update the open state for this specific accordion
    setOpenAccordions(prev => ({
      ...prev,
      [`${page}_${pageNumber}`]: isOpen
    }));
  };

  const handleMediaTypesChange = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "All")) {
      // 'All' is selected, set all media types
      setSelectedMediaTypes(["audio", "video", "pdf"]);
    } else {
      // Update selected media types based on user's selection
      setSelectedMediaTypes([]);
      setSelectedMediaTypes(selectedOptions.map((option) => option.value));
    }
  };

  const addBookPageToCache = () => {
    setIsDownloading(true);
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        action: "addResourceToCache",
        url: `https://mediasea.net/bookDetails/${book._id}`,
      });
    }
    console.log("added book page to cache");
    setTimeout(() => {
    setIsDownloading(false);
    }, 5000);
  };
  const addBookToCache = (url) => {
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        action: "addResourceToCache",
        url: url,
      });
    }
    addBookPageToCache();
  };

  const handleAudioPlay = (voiceFileName) => {
    const audioElements = document.getElementsByTagName("audio");
    for (let i = 0; i < audioElements.length; i++) {
      const audioElement = audioElements[i];
      if (voiceFileName === audioElement.src) {
        audioElement.play();
      } else {
        audioElement.pause();
      }
    }
  };

  useEffect(() => {
    bookServices
      .getExpiryDate(localStorage.getItem("id"), book.codeBase)
      .then((res) => {
        setCodesInfo(res?.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [book]);

  // Keep the cacheDigitalEdition function for manual caching
  const cacheDigitalEdition = async () => {
    if (!book.digitalEdition) return;
    
    setIsDownloading(true);
    
    try {
      const response = await fetch(book.digitalEdition);
      const blob = await response.blob();
      const cache = await caches.open("appV1");
      await cache.put(book.digitalEdition, new Response(blob, {
        headers: {
          "Content-Type": response.headers.get("Content-Type")
        }
      }));
      setIsPDFCached(true);
    } catch (error) {
      console.error("Error caching digital edition:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  // Download the book content based on what's available
  const downloadBookContent = async () => {
    setIsDownloading(true);
    setShowDownloadIndicator(true);
    setDownloadProgress(0);
    
    try {
      // Create arrays to track files
      const mediaFiles = [];
      let pdfFile = null;
      
      // If there's a PDF and it's not cached, add it to the list
      if (hasPDF && !isPDFCached && book.digitalEdition) {
        pdfFile = book.digitalEdition;
      }
      
      // Collect all media files that need to be cached
      if (hasMedia && !isMediaCached) {
        book.pages.forEach(page => {
          if (page.voiceFiles) {
            page.voiceFiles.forEach(file => {
              const url = file.url.replace(
                "https://redsea-books-assets.s3.eu-central-1.amazonaws.com",
                "https://dng2cduv9v2yj.cloudfront.net"
              );
              mediaFiles.push({
                url,
                name: file.name || decodeURIComponent(file.url.split('/').pop().replace('.mp3', '')),
                type: 'audio'
              });
            });
          }
          
          if (page.videoFiles) {
            page.videoFiles.forEach(file => {
              const url = file.url.replace(
                "https://redsea-books-assets.s3.eu-central-1.amazonaws.com",
                "https://dng2cduv9v2yj.cloudfront.net"
              );
              mediaFiles.push({
                url,
                name: file.name || `Video ${file.url.split('/').pop()}`,
                type: 'video'
              });
            });
          }
        });
      }
      
      // Calculate total files to download
      const totalFiles = (pdfFile ? 1 : 0) + mediaFiles.length;
      if (totalFiles === 0) {
        // Nothing to download
        setShowDownloadIndicator(false);
        setIsDownloading(false);
        return;
      }
      
      let completedFiles = 0;
      
      // Function to update progress with current file info
      const updateProgress = (current, total, fileName = null) => {
        const percentage = Math.floor((current / total) * 100);
        setDownloadProgress(percentage);
        if (fileName) setCurrentDownloadFile(fileName);
        console.log(`Downloading: ${current}/${total} (${percentage}%) ${fileName ? `- ${fileName}` : ''}`);
      };
      
      // First download the PDF if needed
      if (pdfFile) {
        try {
          updateProgress(0, totalFiles, "Downloading PDF...");
          
          const response = await fetch(pdfFile);
          if (!response.ok) {
            throw new Error(`Failed to fetch PDF: ${response.status}`);
          }
          
          // Get content length for progress calculation
          const contentLength = +response.headers.get("Content-Length");
          const reader = response.body.getReader();
          let receivedLength = 0;
          const chunks = [];
          
          // Process the stream
          while (true) {
            const { done, value } = await reader.read();
            if (done) break;
            
            chunks.push(value);
            receivedLength += value.length;
            
            // Calculate and update progress within PDF download
            const pdfProgress = Math.round((receivedLength / contentLength) * 100);
            const totalProgress = Math.round((pdfProgress / 100) * (1 / totalFiles) * 100);
            setDownloadProgress(totalProgress);
          }
          
          // Create a new response from the chunks
          const blob = new Blob(chunks);
          const newResponse = new Response(blob, {
            headers: {
              "Content-Type": response.headers.get("Content-Type") || "application/pdf"
            }
          });
          
          // Store in cache
          const cache = await caches.open("appV1");
          await cache.put(pdfFile, newResponse);
          
          setIsPDFCached(true);
          completedFiles++;
          updateProgress(completedFiles, totalFiles, "PDF downloaded successfully");
          
          // Add a small delay after the PDF is downloaded
          await new Promise(resolve => setTimeout(resolve, 1000));
        } catch (error) {
          console.error("Error caching PDF:", error);
          updateProgress(completedFiles, totalFiles, "PDF download failed");
        }
      }
      
      // Now download media files one by one
      for (let i = 0; i < mediaFiles.length; i++) {
        const file = mediaFiles[i];
        try {
          updateProgress(completedFiles, totalFiles, `Downloading ${file.type}: ${file.name}...`);
          
          // Explicitly request this media file from the service worker
          if (navigator.serviceWorker && navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({
              action: "requestMedia",
              url: file.url
            });
          }
          
          // Fetch the file with no-cors mode for CloudFront URLs
          const fetchOptions = file.url.includes('cloudfront.net') ? { mode: 'no-cors' } : {};
          const response = await fetch(file.url, fetchOptions);
          
          // For no-cors responses, we can't check if they're OK, so we just proceed
          if (fetchOptions.mode !== 'no-cors' && !response.ok) {
            throw new Error(`Failed to fetch ${file.type} file: ${response.status}`);
          }
          
          // Get the blob data
          const blob = await response.blob();
          
          // Store in cache with appropriate content type
          const cache = await caches.open("appV1");
          await cache.put(file.url, new Response(blob, {
            headers: {
              'Content-Type': file.type === 'audio' ? 'audio/mpeg' : 
                             file.type === 'video' ? 'video/mp4' : 
                             response.headers.get('Content-Type') || 'application/octet-stream'
            }
          }));
          
          completedFiles++;
          updateProgress(completedFiles, totalFiles, `${file.name} downloaded successfully`);
          
          // Add a short delay between files to prevent overwhelming the network
          if (i < mediaFiles.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        } catch (error) {
          console.error(`Error caching ${file.type}:`, error);
          updateProgress(completedFiles, totalFiles, `${file.name} download failed`);
        }
      }
      
      // Cache the book details page itself
      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          action: "addResourceToCache",
          url: `https://mediasea.net/bookDetails/${book._id}`,
        });
      }
      
      // Check if we have any cached media files
      const cache = await caches.open("appV1");
      const cachedKeys = await cache.keys();
      const hasCachedMedia = cachedKeys.some(request => {
        const url = request.url;
        return url.endsWith('.mp3') || url.endsWith('.mp4') || 
               url.includes('/audio/') || url.includes('/video/');
      });
      
      setIsMediaCached(hasCachedMedia);
      
      // Update to 100% when all processing is done
      updateProgress(totalFiles, totalFiles, "Download completed");
      
    } catch (error) {
      console.error("Error during caching process:", error);
    } finally {
      // Always finish the process, even if there's an error
      setTimeout(() => {
        setShowDownloadIndicator(false);
        setIsDownloading(false);
      }, 1000);
    }
  };

  // Determine download button state based on cache status and content availability
  const getDownloadButtonState = () => {
    if (hasPDF && hasMedia) {
      // Left branch: Book has both PDF and media
      if (isPDFCached && isMediaCached) {
        return {
          text: "Book is available offline",
          disabled: true,
          icon: <OfflinePin />,
          style: { opacity: 0.5, cursor: "not-allowed", color: "white", width: "250px" }
        };
      } else {
        return {
          text: "Download book",
          disabled: isDownloading,
          icon: <CloudDownload />,
          style: { cursor: isDownloading ? "not-allowed" : "pointer", color: "white", width: "250px" }
        };
      }
    } else if (hasPDF && !hasMedia) {
      // Middle branch: Book has only PDF
      if (isPDFCached) {
        return {
          text: "Book is available offline",
          disabled: true,
          icon: <OfflinePin />,
          style: { opacity: 0.5, cursor: "not-allowed", color: "white", width: "250px" }
        };
      } else {
        return {
          text: "Download book",
          disabled: isDownloading,
          icon: <CloudDownload />,
          style: { cursor: isDownloading ? "not-allowed" : "pointer", color: "white", width: "250px" }
        };
      }
    } else if (!hasPDF && hasMedia) {
      // Right branch: Book has only media
      if (isMediaCached) {
        return {
          text: "Book is available offline",
          disabled: true,
          icon: <OfflinePin />,
          style: { opacity: 0.5, cursor: "not-allowed", color: "white", width: "250px" }
        };
      } else {
        return {
          text: "Download book",
          disabled: isDownloading,
          icon: <CloudDownload />,
          style: { cursor: isDownloading ? "not-allowed" : "pointer", color: "white", width: "250px" }
        };
      }
    } else {
      // Bottom right: Book has neither PDF nor media
      return {
        text: "Nothing to download",
        disabled: true,
        style: { opacity: 0.5, cursor: "not-allowed", color: "white", width: "250px" }
      };
    }
  };

  return (
    <>
      <Header />
      {isLoading && !userHasTheBook ? (
        <h1>Loading...</h1>
      ) : (
        <div className="book-details">
          <SideBar />
          <div className="main-content">
            <Dialog
              open={viewSample}
              onClose={() => setViewSample(false)}
              aria-labelledby="form-dialog-title"
              className="parentDialog"
            >
              <DialogContent className="dialogContainer">
                {book.sample ? (
                  // <object
                  //   data={book.sample.concat("#toolbar=0")}
                  //   type="application/pdf"
                  //   className="pdfContainer"
                  // ></object>
                  <PDFViewer pdfURL={book.sample} sample={true} />
                ) : (
                  <h1>No Sample Available</h1>
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setViewSample(false);
                  }}
                  color="primary"
                  className="cancelButton"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
            <Grid container spacing={2} className="book-info">
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                className="book-photo-grid"
              >
                <img
                  className="book-thumbnail"
                  src={book?.thumbnail.replace(
                    "https://redsea-books-assets.s3.eu-central-1.amazonaws.com",
                    "https://dng2cduv9v2yj.cloudfront.net"
                )}
                  alt="Book Thumbnail"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={10}
                xl={10}
                className="book-meta-grid"
              >
                <h1 className="book-title-header">{book.title}</h1>
                {codesInfo?.codes[0]?.activeUntil && (
                  <div className="book-expiry">
                    <span className="expiry-date-book">
                      Expires on:{" "}
                    {codesInfo?.codes[0]?.activeUntil?.split("T")[0]}
                  </span>
                </div>
                )}
                <div className="book-info">
                  {book.description && (
                    <p className="book-description">
                      <span>
                        {showFullDescription
                          ? book?.description
                          : `${book?.description?.slice(0, 350)}...`}{" "}
                      </span>
                      {showFullDescription ? (
                        <span onClick={toggleDescription} className="show-more">
                          Read Less
                        </span>
                      ) : (
                        <span onClick={toggleDescription} className="show-more">
                          Read More
                        </span>
                      )}
                    </p>
                  )}
                </div>
                <div className="book-meta">
                  <div className="book-meta-info">
                    <Typography className="book-language">
                      Language:{" "}
                      <span className="book-language-span">
                        {book?.language}
                      </span>
                    </Typography>
                    <Typography className="book-year">
                      Publish Year:{" "}
                      <span className="book-year-span">
                        {book?.publishYear}
                      </span>
                    </Typography>
                  </div>
                  <div className="book-actions">
                    {showDownloadIndicator ? (
                      <div className="progress-container">
                        <CircularProgress 
                          variant="determinate" 
                          value={downloadProgress} 
                          size={24}
                          style={{ marginRight: "10px" }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span>{currentDownloadFile || 'Preparing download...'}</span>
                          <span style={{ fontSize: '0.8rem', opacity: 0.8 }}>{downloadProgress}% complete</span>
                        </div>
                      </div>
                    ) : (
                      <button
                        className="action-button-download"
                        disabled={getDownloadButtonState().disabled || isDownloading}
                        style={getDownloadButtonState().style}
                        onClick={downloadBookContent}
                      >
                        {getDownloadButtonState().icon && (
                          <span className="button-icon">
                            {getDownloadButtonState().icon}
                          </span>
                        )}
                        {getDownloadButtonState().text}
                      </button>
                    )}
                    <button
                      className="action-button-download"
                      onClick={() => setViewSample(true)}
                    >
                      View Sample
                    </button>
                    {book?.digitalEdition && (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <button className="action-button-download">
                          <span className="digital-link">
                            <Link
                              style={{ color: "inherit", textDecoration: "none" }}
                              to={`/DigitalBook/${book._id}`}
                            >
                              Digital Edition
                            </Link>
                          </span>
                        </button>
                      </div>
                    )}
                    <button className="sidebar-toggle" onClick={toggleSidebar}>
                      Content <AutoStoriesIcon className="book-icon" />
                    </button>
                    <button
                      className="sidebar-toggle-mobile"
                      onClick={toggleSidebar}
                    >
                      Content <AutoStoriesIcon className="book-icon" />
                    </button>
                  </div>
                </div>
              </Grid>
              <div className="book-actions-filter">
                <label className="media-type-label">Media Types: </label>
                <Select
                  isMulti
                  options={mediaTypes}
                  value={mediaTypes.filter((option) =>
                    selectedMediaTypes.includes(option.value)
                  )}
                  onChange={handleMediaTypesChange}
                  className="media-type-selector"
                  placeholder="Select media type..."
                />
              </div>
            </Grid>
            <div className="page-container">
              {book.pages.map((page, index) => {
                return (
                  <div
                    key={page.number}
                    id={`page_${page.number}`}
                    className="page"
                  >
                    {(selectedMediaTypes.includes("audio") &&
                      page.voiceFiles) ||
                    (selectedMediaTypes.includes("video") && page.videoFiles) ||
                    (selectedMediaTypes.includes("pdf") && page.pdfFiles) ? (
                      <h2>Page {page.number}</h2>
                    ) : selectedMediaTypes.includes("All") ? (
                      <h2>Page {page.number}</h2>
                    ) : selectedMediaTypes.length == 0 ? (
                      <h2>Page {page.number}</h2>
                    ) : null}

                    {((selectedMediaTypes.length > 0 &&
                      selectedMediaTypes.includes("audio")) ||
                      (selectedMediaTypes.length > 0 &&
                        selectedMediaTypes.includes("All"))) && (
                      <>
                        {page.voiceFiles && (
                          <>
                            {page.voiceFiles.map((voiceFile, index) => {
                              const encodedVoiceFileUrl = btoa(voiceFile.url.replace(
                                "https://redsea-books-assets.s3.eu-central-1.amazonaws.com",
                                "https://dng2cduv9v2yj.cloudfront.net"
                              ));
                              const accordionKey = `${index}_${page.number}`;
                              
                              return (
                                <React.Fragment key={accordionKey}>
                                  <div className="audio-file-title">
                                    <HeadsetIcon />
                                    <p
                                      onClick={() => {
                                        toggleAudioControls(index, page.number);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {voiceFile.name ? voiceFile.name : decodeURIComponent(
                                        voiceFile.url
                                          ?.split("/")
                                          ?.pop()
                                          ?.replace(".mp3", "")
                                          ?.replace(/_/g, " ")
                                          ?.replace(/\+/g, " ")
                                      )}
                                    </p>
                                  </div>
                                  <div
                                    style={{ display: "none" }}
                                    className={`audio-play-buttons_${index}_${page.number}`}
                                  >
                                    {openAccordions[accordionKey] && (
                                      <AudioPlayer
                                        src={atob(encodedVoiceFileUrl)}
                                        className={`audio_${page.number}`}
                                        onPlay={() => {
                                          handleAudioPlay(atob(encodedVoiceFileUrl));
                                        }}
                                        progressJumpStep={5000}
                                      />
                                    )}
                                  </div>
                                </React.Fragment>
                              );
                            })}
                          </>
                        )}
                      </>
                    )}
                    {((selectedMediaTypes.length > 0 &&
                      selectedMediaTypes.includes("video")) ||
                      (selectedMediaTypes.length > 0 &&
                        selectedMediaTypes.includes("All"))) &&
                      page.videoFiles &&
                      page.videoFiles.map((videoFile, index) => {
                        const accordionKey = `video_${index}_${page.number}`;
                        return (
                          <React.Fragment key={index}>
                            <div className="video-file-title">
                              <p
                                onClick={() => {
                                  const videoElement = document.querySelector(
                                    `.video-container-${index}-${page.number}`
                                  );
                                  const isOpen = videoElement.style.display !== "block";
                                  videoElement.style.display = isOpen ? "block" : "none";
                                  setOpenAccordions(prev => ({
                                    ...prev,
                                    [accordionKey]: isOpen
                                  }));
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                Video {index + 1}
                              </p>
                            </div>
                            <div 
                              className={`video-container-${index}-${page.number}`}
                              style={{ display: "none" }}
                            >
                              {openAccordions[accordionKey] && (
                                <>
                                  <video
                                    controls
                                    className="video-file"
                                    src={videoFile.url.replace(
                                      "https://redsea-books-assets.s3.eu-central-1.amazonaws.com",
                                      "https://dng2cduv9v2yj.cloudfront.net"
                                    )}
                                  ></video>
                                  <br />
                                </>
                              )}
                            </div>
                          </React.Fragment>
                        );
                      })}
                    {((selectedMediaTypes.length > 0 &&
                      selectedMediaTypes.includes("pdf")) ||
                      (selectedMediaTypes.length > 0 &&
                        selectedMediaTypes.includes("All"))) &&
                      page.pdfFile && (
                        <PDFViewer pdfURL={page.pdfFile} sample={true} />
                      )}
                    {(selectedMediaTypes.includes("audio") && page.voiceFile) ||
                    (selectedMediaTypes.includes("video") && page.videoFiles) ||
                    (selectedMediaTypes.includes("pdf") && page.pdfFile) ? (
                      <hr />
                    ) : selectedMediaTypes.includes("All") ? (
                      <hr />
                    ) : selectedMediaTypes.length == 0 ? (
                      <hr />
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="sidebar collapsed">
            <div className="sidebar-content">
              <div className="book-info-side">
                <img className="book-thumbnail-side" src={book?.thumbnail.replace(
                            "https://redsea-books-assets.s3.eu-central-1.amazonaws.com",
                            "https://dng2cduv9v2yj.cloudfront.net"
                        )}></img>
                <h4>{book.title}</h4>
              </div>
              <ul>
                {book.pages.map((page) => (
                  <>
                    <li key={page.number}>
                      <a href={`#page_${page.number}`}>Page {page.number}</a>
                    </li>
                    <hr className="index-hr" />
                  </>
                ))}
              </ul>
            </div>
          </div>

          <div className="floating-index-bar collapsed">
            {/* Index content goes here */}
            <div className="book-info-mobile">
              <img className="book-thumbnail-mobile" src={book?.thumbnail.replace(
                            "https://redsea-books-assets.s3.eu-central-1.amazonaws.com",
                            "https://dng2cduv9v2yj.cloudfront.net"
                        )}></img>
              <h4 className="book-title-mobile">{book.title}</h4>
              <div className="book-exit-icon">
                <CloseIcon className="close-icon" onClick={toggleSidebar} />
              </div>
            </div>

            <div className="book-index-mobile">
              <ul>
                {book.pages.map((page) => (
                  <>
                    <li key={page.number}>
                      <a href={`#page_${page.number}`}>Page {page.number}</a>
                    </li>
                    <hr className="index-hr" />
                  </>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
      <Footer />
      <BottomNav />
    </>
  );
};

export default BookDetails;
